module.exports = __webpack_public_path__ + "static/media/kostenindicatie.7a324fc5.jpg";